import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { type WorkspaceIdentity } from '@modules/common/services/workspace-identity.service';
import { Button2Component } from '@frontendlib/components/components/button/button2.component';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { itemWorkspace, type WorkspaceItem } from './item-workspace-scope';

@Component({
  selector: 'app-item-workspace-chip',
  templateUrl: './item-workspace-chip.component.html',
  imports: [Button2Component, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemWorkspaceChipComponent {
  public readonly revision = input(0);
  public readonly identity = input<WorkspaceIdentity>();
  public readonly item = input<WorkspaceItem>();
  public readonly openAccess = input<() => void>(() => undefined);
  /** A narrow header (#1965): the initials or the lock only; the name stays in the accessible label. */
  public readonly compact = input(false);
  protected readonly workspace = computed(() => {
    this.revision();
    return itemWorkspace(this.identity(), this.item());
  });
  protected readonly label = computed(() =>
    this.workspace() === 'team' ? `${this.identity()?.spaceTitle} team access` : 'My workspace access',
  );
  protected readonly initials = computed(() =>
    (this.identity()?.spaceTitle ?? '')
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((word) => word[0])
      .join('')
      .toUpperCase(),
  );
  protected open(): void {
    this.openAccess()();
  }
}
